<template>
<el-carousel>
  <el-carousel-item>
    <img class="d-block" src="img/benefit_mobility.jpg" alt="First slide" />

  </el-carousel-item>
  <el-carousel-item>
    <img class="d-block" src="img/benefit_commercial.jpg" alt="Second slide" />

  </el-carousel-item>
  <el-carousel-item>
    <img class="d-block" src="img/benefit_hotel.jpg" alt="Third slide" />

  </el-carousel-item>
</el-carousel>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  }
};
</script>
<style>
.el-carousel__container {
    position: relative;
    height: 700px;
}
.el-carousel__arrow {
  border: 2px solid black;
  border-color: #cf116d;
}
@media (max-width: 800px) {
.el-carousel__container {
    position: relative;
    height: 300px;
}
}
</style>
